import React from 'react'
import { graphql } from 'gatsby'
import { Container } from 'theme-ui'
import Layout from '@solid-ui-layout/Layout'
import Seo from '@solid-ui-components/Seo'
import Divider from '@solid-ui-components/Divider'
import ModalSimple from '@solid-ui-blocks/Modal/Block02'
import Header from '@solid-ui-blocks/Header/Block01'
import Hero from '@solid-ui-blocks/Hero/Block01'
import Content from '@solid-ui-blocks/Content/Block02'
import Gallery from '../../blocks/Blog/Block01'
import Quote from '../../blocks/Quotes/Block01'
import Contact from '@solid-ui-blocks/CallToAction/Block02'
import Team from '@solid-ui-blocks/Hero/Block03'
import Footer from '@solid-ui-blocks/Footer/Block01'
import { normalizeBlockContentNodes } from '@blocks-helpers'
import styles from './_styles'

const Services03 = props => {
  const { allBlockContent } = props.data
  const content = normalizeBlockContentNodes(allBlockContent?.nodes)

  return (
    <Layout {...props}>
      <Seo title='Home' />
      {/* Modals */}
      <ModalSimple content={content['privacy-policy']} />
      <ModalSimple content={content['disclaimer']} />
      {/* Blocks */}
      <Header content={content['header']} />
      <Divider space='5' />
      <Divider space='5' />
      <Container variant='wide' sx={styles.overviewContainer}>
        <Hero content={content['hero']} /> 
        <Divider space='-2' />
      </Container>
      <Divider space='2' />
      <Content content={content['services-intro']} />
      <Divider space='1' />
      <Gallery content={content['gallery']} />
      <Divider space='2' />
      <Quote content={content['quote']} />
      <Divider space='5' />
      <Container variant='wide' sx={styles.teamContainer}>
      <Team content={content['team']} />
      </Container>
      <Divider space='4' />
      <Contact content={content['cta']} />
      <Divider space='5' />
      <Footer content={content['footer']} />
    </Layout>
  )
}

export const query = graphql`
  query siteServices03BlockContent {
    allBlockContent(
      filter: { page: { in: ["site/products", "site/shared"] } }
    ) {
      nodes {
        ...BlockContent
      }
    }
  }
`

export default Services03
